import React from 'react';
import { useHistory } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import { red } from '@material-ui/core/colors';
import { Button, Dialog, DialogTitle, DialogContent, Box, Typography, Divider, Link } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import consts from './../../../main/consts';

const useStyles = makeStyles((theme) => ({
  box:{
    borderLeft: `5px solid ${red[500]}`,    
  },
  title:{
    padding: 10,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'  
  },
  listContent: {
    maxHeight: '50vh',
    minWidth: 380,
    minHeight: 80,
  },
  text: {
    height: '100%',
  },
  spacingBottom: {
    marginBottom: 10,
  },
  action: {
    padding: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row-reverse',
  },
  numeroPedido:{
    marginTop: 10,    
  },
  link:{
    cursor: 'pointer'
  }
}));

export default function Popup(props) {
  const { open, data, handleClose } = props;
  const classes = useStyles();
  const history = useHistory();

  const goToPedido = () => {
    history.push(`${consts.CONTEXT}/history/${data.numero_pedido}`, { data: { page: 'history' } });
    handleClose();
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}        
      >
        <Box className={classes.box}>
          <Box className={classes.title}>
            <InfoIcon color="primary" fontSize="large" />
            <DialogTitle className={classes.title}>
            <strong>{data.titulo}</strong>
            </DialogTitle>
          </Box>
          <Divider />
          <DialogContent className={classes.listContent}>
            <Box container direction="column" justify="space-between" alignItems="center" className={classes.text}>              
                <Typography>{data.mensagem}</Typography> 
            </Box>
            <Box className={classes.numeroPedido}>
              <Typography>
                <strong>Nº do Pedido: 
                <Link onClick={goToPedido} className={classes.link}> {data.numero_pedido}</Link></strong>
              </Typography>
            </Box>
          </DialogContent>
          <Divider />
          <Box className={classes.action}>
            <Button onClick={handleClose} variant="contained" color="primary" startIcon={<CloseIcon />} autoFocus >Fechar</Button>
          </Box>
        </Box>
      </Dialog>
    </>
  )
}
